import { useCallback } from 'react';

import { useActivatePromotionMutation } from 'generated/graphql-gateway';

import { ActivatePromotionArgs, ActivatePromotionResult } from '../types';

export function useLegacyActivatePromotion(): ActivatePromotionResult {
  const [activatePromotionMutation] = useActivatePromotionMutation();

  const activatePromotion = useCallback(
    async ({ loyaltyId, promotionId }: ActivatePromotionArgs) => {
      await activatePromotionMutation({ variables: { loyaltyId, promotionId } });
    },
    [activatePromotionMutation]
  );

  return { activatePromotion };
}
